let resolveLogonProfile = false;
let rejectLogonProfile = false;
let payload = null;
let intervalId;

window.eventListener(document, 'ATS_LOGON_PROFILE_SUCCESS', (data) => {
  payload = data;
  resolveLogonProfile = true;
});

window.eventListener(document, 'ATS_LOGON_PROFILE_FAILED', (error) => {
  payload = error;
  rejectLogonProfile = true;
});

export default () => {
  return new Promise((resolve, reject) => {
    intervalId = setInterval(() => {
      if (resolveLogonProfile) {
        clearInterval(intervalId);
        resolve(payload);
      }

      if (rejectLogonProfile) {
        clearInterval(intervalId);
        reject(payload);
      }
    }, 100);
  });
};
